import React from 'react';
import { useMode } from '../context/ModeContext';
import { Briefcase, Home } from 'lucide-react';
import './ModeToggle.css';

const ModeToggle = () => {
  const { mode, toggleMode, isDualModeEnabled } = useMode();

  // Only show for contractors
  if (!isDualModeEnabled) {
    return null;
  }

  return (
    <div className="mode-toggle-container">
      <button
        onClick={toggleMode}
        className={`mode-toggle ${mode}`}
        title={`Switch to ${mode === 'business' ? 'homeowner' : 'business'} mode`}
      >
        <span className={`mode-option ${mode === 'business' ? 'active' : ''}`}>
          <span className="mode-icon"><Briefcase size={14} /></span>
          <span className="mode-label">Business</span>
        </span>
        <span className="mode-divider"></span>
        <span className={`mode-option ${mode === 'homeowner' ? 'active' : ''}`}>
          <span className="mode-icon"><Home size={14} /></span>
          <span className="mode-label">Home</span>
        </span>
        <div className={`mode-slider ${mode}`}></div>
      </button>
    </div>
  );
};

export default ModeToggle;
